export const PATsRoutes = {
	base: '/company/integrations/personal-access-tokens',
	new: '/company/integrations/personal-access-tokens/new',
} as const;

export const PATsFeatureFlag = 'personal-access-tokens-mgmt-ui';
